import { render, staticRenderFns } from "./BaseDropdownMenu.vue?vue&type=template&id=0addf29c&scoped=true&"
import script from "./BaseDropdownMenu.vue?vue&type=script&lang=ts&"
export * from "./BaseDropdownMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDropdownMenu.vue?vue&type=style&index=0&id=0addf29c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0addf29c",
  null
  
)

export default component.exports